module.exports = __webpack_public_path__ + "static/media/4.af6c3ec0.svg";